import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c28672d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-4" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "d-flex justify-content-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 info" }, [
  /*#__PURE__*/_createElementVNode("p", null, " An emaill with a verification code has been sent to your email. Enter the code to continue. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Didn’t get a verification code?")
], -1))
const _hoisted_6 = { class: "row px-2 py-4" }
const _hoisted_7 = { class: "col-6 border-right" }
const _hoisted_8 = { class: "d-flex justify-content-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get a new verification code.", -1))
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "d-flex justify-content-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get a new verfication code with a different email.", -1))

import { ref, inject, watch } from "vue";
import { RefreshRight, Message } from "@element-plus/icons-vue";
import axios from "axios";
import { ElNotification } from "element-plus";
import { isMobile } from "@/core/config/WindowConfig";

export default /*#__PURE__*/_defineComponent({
  __name: 'CodeForm',
  setup(__props) {

const formData = inject("data");
const step = inject("step");
const code = ref(["", "", "", "", "", "", ""]);
const isLoading = ref(false);
const transitionLoading = ref(false);
const showPopover = ref(false);
const onCodeChange = (index: number) => {
  if (index < 6 && code.value[index] !== "") {
    const nextInput = document.getElementsByName(
      `pincode-${index + 2}`
    )[0] as HTMLInputElement;
    nextInput.focus();
  }
};
const onKeyDown = (event: KeyboardEvent, index: number) => {
  if (event.key === "Backspace" || event.key === "Delete") {
    if (index > 0 && code.value[index] == "") {
      event.preventDefault();
      const prevInput = document.getElementsByName(
        `pincode-${index}`
      )[0] as HTMLInputElement;
      prevInput.focus();
    }
  }
};

const onPaste = (event: ClipboardEvent, index: number) => {
  const paste = event.clipboardData?.getData("text") || "";
  if (paste.length > 0) {
    event.preventDefault();
    for (let i = 0; i < paste.length && index + i < code.value.length; i++) {
      code.value[index + i] = paste[i];
      const input = document.getElementsByName(
        `pincode-${index + i + 1}`
      )[0] as HTMLInputElement;
      input.value = paste[i];
    }
    if (index + paste.length < code.value.length) {
      const nextInput = document.getElementsByName(
        `pincode-${index + paste.length + 1}`
      )[0] as HTMLInputElement;
      nextInput.focus();
    }
  }
};

const resentCode = async (values) => {
  isLoading.value = true;
  try {
    await axios
      .post("/api/v2/auth/password-reset/code", {
        email: formData.value.email,
      })
      .then(() => {
        ElNotification({
          title: "Success",
          message: "Verification code resent successfully",
          type: "success",
        });
        code.value = ["", "", "", "", "", ""];
        showPopover.value = false;
      });
  } catch (error) {
    console.log(error);
    ElNotification({
      title: "Error",
      message: "Failed to resend verification code",
      type: "error",
    });
  }
  isLoading.value = false;
};

watch(
  code,
  (newCode) => {
    if (newCode.join("").length === 7) {
      transitionLoading.value = true;
      setTimeout(() => {
        formData.value.code = newCode.join("");
        step.value = 2;
        transitionLoading.value = false;
      }, 2000);
    }
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("fields.oneTimeCode")), 1),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code.value[0]) = $event)),
        type: "tel",
        name: "pincode-1",
        maxlength: "1",
        pattern: "[\\d]*",
        tabindex: "1",
        autocomplete: "off",
        onInput: _cache[1] || (_cache[1] = ($event: any) => (onCodeChange(0))),
        onKeydown: _cache[2] || (_cache[2] = (event) => onKeyDown(event, 0)),
        onPaste: _cache[3] || (_cache[3] = (event) => onPaste(event, 0))
      }, null, 544), [
        [_vModelText, code.value[0]]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((code.value[1]) = $event)),
        type: "tel",
        name: "pincode-2",
        maxlength: "1",
        pattern: "[\\d]*",
        tabindex: "2",
        autocomplete: "off",
        onInput: _cache[5] || (_cache[5] = ($event: any) => (onCodeChange(1))),
        onKeydown: _cache[6] || (_cache[6] = (event) => onKeyDown(event, 1)),
        onPaste: _cache[7] || (_cache[7] = (event) => onPaste(event, 1))
      }, null, 544), [
        [_vModelText, code.value[1]]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((code.value[2]) = $event)),
        type: "tel",
        name: "pincode-3",
        maxlength: "1",
        pattern: "[\\d]*",
        tabindex: "3",
        autocomplete: "off",
        onInput: _cache[9] || (_cache[9] = ($event: any) => (onCodeChange(2))),
        onKeydown: _cache[10] || (_cache[10] = (event) => onKeyDown(event, 2)),
        onPaste: _cache[11] || (_cache[11] = (event) => onPaste(event, 2))
      }, null, 544), [
        [_vModelText, code.value[2]]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((code.value[3]) = $event)),
        type: "tel",
        name: "pincode-4",
        maxlength: "1",
        pattern: "[\\d]*",
        tabindex: "4",
        autocomplete: "off",
        onInput: _cache[13] || (_cache[13] = ($event: any) => (onCodeChange(3))),
        onKeydown: _cache[14] || (_cache[14] = (event) => onKeyDown(event, 3)),
        onPaste: _cache[15] || (_cache[15] = (event) => onPaste(event, 3))
      }, null, 544), [
        [_vModelText, code.value[3]]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((code.value[4]) = $event)),
        type: "tel",
        name: "pincode-5",
        maxlength: "1",
        pattern: "[\\d]*",
        tabindex: "5",
        autocomplete: "off",
        onInput: _cache[17] || (_cache[17] = ($event: any) => (onCodeChange(4))),
        onKeydown: _cache[18] || (_cache[18] = (event) => onKeyDown(event, 4)),
        onPaste: _cache[19] || (_cache[19] = (event) => onPaste(event, 4))
      }, null, 544), [
        [_vModelText, code.value[4]]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((code.value[5]) = $event)),
        type: "tel",
        name: "pincode-6",
        maxlength: "1",
        pattern: "[\\d]*",
        tabindex: "6",
        autocomplete: "off",
        onInput: _cache[21] || (_cache[21] = ($event: any) => (onCodeChange(5))),
        onKeydown: _cache[22] || (_cache[22] = (event) => onKeyDown(event, 5)),
        onPaste: _cache[23] || (_cache[23] = (event) => onPaste(event, 5))
      }, null, 544), [
        [_vModelText, code.value[5]]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((code.value[6]) = $event)),
        type: "tel",
        name: "pincode-7",
        maxlength: "1",
        pattern: "[\\d]*",
        tabindex: "7",
        autocomplete: "off",
        onInput: _cache[25] || (_cache[25] = ($event: any) => (onCodeChange(6))),
        onKeydown: _cache[26] || (_cache[26] = (event) => onKeyDown(event, 6)),
        onPaste: _cache[27] || (_cache[27] = (event) => onPaste(event, 6))
      }, null, 544), [
        [_vModelText, code.value[6]]
      ])
    ]),
    _hoisted_4,
    _createVNode(_component_el_popover, {
      placement: "top",
      width: _unref(isMobile) ? 320 : 400,
      trigger: "click",
      visible: showPopover.value,
      "onUpdate:visible": _cache[29] || (_cache[29] = ($event: any) => ((showPopover).value = $event))
    }, {
      reference: _withCtx(() => [
        _hoisted_5
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_icon, {
                    size: 40,
                    class: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(RefreshRight))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", {
                    class: "info-3",
                    onClick: resentCode
                  }, "Resent Code"),
                  _hoisted_10
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_el_icon, {
                    size: 40,
                    class: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Message))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("p", {
                    class: "info-3",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (step.value = 0))
                  }, "Change Email"),
                  _hoisted_14
                ])
              ])
            ])
          ])
        ])), [
          [_directive_loading, isLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["width", "visible"])
  ])), [
    [_directive_loading, transitionLoading.value]
  ])
}
}

})